var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    width: 13.246,
    height: 13.615,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6098",
    "data-name": "Group 6098",
    transform: "translate(-370 -2285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 36,
    height: 36,
    rx: 18,
    transform: "translate(370 2285)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6072",
    "data-name": "Group 6072",
    transform: "translate(381 2296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6042",
    "data-name": "Group 6042",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8529",
    "data-name": "Path 8529",
    d: "M8.666.049A.464.464,0,0,0,8.46.007c-1.027,0-2.055-.02-3.082.008A7.841,7.841,0,0,0,3.761.2,3.674,3.674,0,0,0,1.236,2.072a2.777,2.777,0,0,0,2.019,4.1,10.068,10.068,0,0,0,1.119.059,1.6,1.6,0,0,0,.374,1.846L4.5,8.116c-.546.073-1.1.116-1.637.227A3.86,3.86,0,0,0,.67,9.473a2.155,2.155,0,0,0-.5,2.391,2.586,2.586,0,0,0,1.651,1.429,6.375,6.375,0,0,0,3.268.2,4.58,4.58,0,0,0,2.421-1.139,2.8,2.8,0,0,0,.766-3.079A3.478,3.478,0,0,0,7.231,7.987c-.325-.273-.668-.525-.989-.8a.8.8,0,0,1-.1-1.277,6.178,6.178,0,0,1,.7-.644,2.771,2.771,0,0,0,.374-3.93,6.566,6.566,0,0,0-.577-.54l.021-.1a2,2,0,0,0,2-.641m-1.818,9.8a1.7,1.7,0,0,1-.672,2.732,4.015,4.015,0,0,1-1.7.276,3.8,3.8,0,0,1-2-.558,1.828,1.828,0,0,1-.719-2.4A2.228,2.228,0,0,1,3.188,8.849,6.162,6.162,0,0,1,5.178,8.6a.362.362,0,0,1,.2.038A17.268,17.268,0,0,1,6.848,9.852m-1.8-4.177A1.517,1.517,0,0,1,3.49,5.242a3.675,3.675,0,0,1-.958-3.311A1.459,1.459,0,0,1,3.689.735a1.57,1.57,0,0,1,1.6.495,3.73,3.73,0,0,1,.941,1.96c.042.214.058.434.087.651A1.62,1.62,0,0,1,5.049,5.675",
    transform: "translate(0.001 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8530",
    "data-name": "Path 8530",
    d: "M211.363,109.832c0-.148-.059-.2-.2-.2-.4.005-.807,0-1.211,0h-.366v-.264c0-.432-.005-.864,0-1.3,0-.158-.052-.218-.21-.208a4.3,4.3,0,0,1-.489,0c-.147-.008-.2.047-.2.2.007.453,0,.907,0,1.36v.212c-.545,0-1.055,0-1.564,0-.157,0-.218.056-.211.212s.008.326,0,.489.054.2.2.2c.382-.007.765,0,1.147,0h.427c0,.486,0,.939,0,1.392s-.06.39.4.392c.491,0,.491,0,.491-.5V110.56c.038-.017.051-.028.063-.028.347,0,.694,0,1.041-.005.7,0,.7,0,.675-.7",
    transform: "translate(-198.123 -103.283)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8d961e5678244e939c625fb5e533eaa1.svg";
export { ForwardRef as ReactComponent };